var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemoveDuplicates = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M15.304 13.62c.137 0 .249.109.249.242a.245.245 0 0 1-.249.241H13.67a.245.245 0 0 1-.249-.24v-.003a.245.245 0 0 1 .249-.24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M14.487 15.931c1.177 0 2.131-.926 2.131-2.069s-.954-2.069-2.131-2.069-2.132.926-2.132 2.07c0 1.142.955 2.068 2.132 2.068m1.598-2.069c0 .857-.715 1.552-1.598 1.552s-1.599-.695-1.599-1.552.716-1.552 1.599-1.552 1.598.695 1.598 1.552",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M8.322 6h4.744c.785 0 1.42.618 1.42 1.38v.275h2.843c.785 0 1.421.618 1.421 1.38v7.586c0 .762-.636 1.379-1.421 1.379h-6.395c-.785 0-1.42-.617-1.42-1.38v-.275H6.67c-.785 0-1.421-.618-1.421-1.38V8.713h.002a.5.5 0 0 1 .182-.375l2.46-2.177a.65.65 0 0 1 .428-.16zm5.312 1.38v.275h-1.05v.001c-.15 0-.303.05-.427.16l-2.46 2.177a.5.5 0 0 0-.182.375h-.002v5.15H6.671a.56.56 0 0 1-.568-.553V9.268h2.226c.34 0 .616-.244.616-.544V6.828h4.12a.56.56 0 0 1 .57.551Zm-3.268 3.542h2.226c.34 0 .616-.244.616-.544V8.483h4.12a.56.56 0 0 1 .57.551v7.587a.56.56 0 0 1-.57.551h-6.394a.56.56 0 0 1-.568-.551z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemoveDuplicates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/remove-duplicates.c5d35f6e.svg";